/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2
 */

export const ActionComponentTypename = 'com.hubspot.ai.agent.models.core.ActionComponent';
export const AgentComponentTypename = 'com.hubspot.ai.agent.models.core.AgentComponent';
export const AgentTemplateComponentTypename = 'com.hubspot.ai.agent.models.core.AgentTemplateComponent';
export const AviatorAgentComponentTypename = 'com.hubspot.ai.agent.models.core.AviatorAgentComponent';
export const BooleanAgentInputTypename = 'com.hubspot.ai.agent.models.core.BooleanAgentInput';
export const BuiltInToolComponentTypename = 'com.hubspot.ai.agent.models.core.BuiltInToolComponent';
export const ChirpRpcComponentTypename = 'com.hubspot.ai.agent.models.core.ChirpRpcComponent';
export const ChirpToolBundleComponentTypename = 'com.hubspot.ai.agent.models.core.ChirpToolBundleComponent';
export const CrmObjectCoordinatesAgentInputTypename = 'com.hubspot.ai.agent.models.core.CrmObjectCoordinatesAgentInput';
export const FileAgentInputTypename = 'com.hubspot.ai.agent.models.core.FileAgentInput';
export const FilesAgentInputTypename = 'com.hubspot.ai.agent.models.core.FilesAgentInput';
export const HookComponentTypename = 'com.hubspot.ai.agent.models.core.HookComponent';
export const KnowledgeBoxComponentTypename = 'com.hubspot.ai.agent.models.core.KnowledgeBoxComponent';
export const ListAgentInputTypename = 'com.hubspot.ai.agent.models.core.ListAgentInput';
export const MapAgentInputTypename = 'com.hubspot.ai.agent.models.core.MapAgentInput';
export const McpServerComponentTypename = 'com.hubspot.ai.agent.models.core.McpServerComponent';
export const McpServerV2ComponentTypename = 'com.hubspot.ai.agent.models.core.McpServerV2Component';
export const NullAgentInputTypename = 'com.hubspot.ai.agent.models.core.NullAgentInput';
export const NumberAgentInputTypename = 'com.hubspot.ai.agent.models.core.NumberAgentInput';
export const SkillComponentTypename = 'com.hubspot.ai.agent.models.core.SkillComponent';
export const StringAgentInputTypename = 'com.hubspot.ai.agent.models.core.StringAgentInput';
export const FindActionUsageRequestTypename = 'com.hubspot.ai.agent.rpc.models.usage.FindActionUsageRequest';
export const FindBuiltInToolUsageRequestTypename = 'com.hubspot.ai.agent.rpc.models.usage.FindBuiltInToolUsageRequest';
export const FindChirpRpcUsageRequestTypename = 'com.hubspot.ai.agent.rpc.models.usage.FindChirpRpcUsageRequest';
export const FindKnowledgeBoxUsageRequestTypename = 'com.hubspot.ai.agent.rpc.models.usage.FindKnowledgeBoxUsageRequest';
export const FindMcpUsageRequestTypename = 'com.hubspot.ai.agent.rpc.models.usage.FindMcpUsageRequest';

/**
 *  Represents a validation error for a specific component (action, knowledge box, etc.).
 *  This structured format allows the frontend to construct user-facing error messages.
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const getAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstance',
  auth: 'app',
  fingerprint: 'luxHuQpJJYhxAYHD89ObpBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesByIDsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesByIDs',
  auth: 'app',
  fingerprint: 'v_Hi8JpYU3jhtajEzmTrrRDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesWithSnapshotsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesWithSnapshots',
  auth: 'app',
  fingerprint: '9QKX_6KF_GF5Me_tcRm6xhDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesByWorkflowIdRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesByWorkflowId',
  auth: 'app',
  fingerprint: 'jhR4yXLMTW1k3bNybYzyiRDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesByStatusRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesByStatus',
  auth: 'app',
  fingerprint: 'VItEKjqHl_c5MvMJK5hu5hDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getActiveAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getActiveAgentInstances',
  auth: 'app',
  fingerprint: 'tt8k1TqizUY5MvMJK5hu5hDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'listAgentInstances',
  auth: 'app',
  fingerprint: 'FM9XVOlqZyw5MvMJK5hu5hDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'searchAgentInstances',
  auth: 'app',
  fingerprint: 'YA5lK2Rcr5Y5MvMJK5hu5hDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createAgentInstance',
  auth: 'app',
  fingerprint: 'J4krSsNHBRK1CUKbM05iwhDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstance',
  auth: 'app',
  fingerprint: 'oLofa8HMmcxxAYHD89ObpBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceV2',
  auth: 'app',
  fingerprint: 'oLofa8HMmcxxAYHD89ObpBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const patchAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'patchAgentInstance',
  auth: 'app',
  fingerprint: 'dczjYB0hcflxAYHD89ObpBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const factoryResetRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'factoryReset',
  auth: 'app',
  fingerprint: 'luxHuQpJJYhxAYHD89ObpBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const factoryResetV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'factoryResetV2',
  auth: 'app',
  fingerprint: 'o0RYNvpITsVxAYHD89ObpBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resetToLatestTemplateRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'resetToLatestTemplate',
  auth: 'app',
  fingerprint: 'Im2kC-4d0Bs7REa5ovXKyRDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const softDeleteAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'softDeleteAgentInstance',
  auth: 'app',
  fingerprint: 'luxHuQpJJYhzxnLXxOhAlxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const softDeleteAgentInstanceV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'softDeleteAgentInstanceV2',
  auth: 'app',
  fingerprint: 'bquNPpxFM9hzxnLXxOhAlxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createInstanceFromTemplateRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createInstanceFromTemplate',
  auth: 'app',
  fingerprint: 'jNKCPmkGdefo-EQ3I6ABhxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createInstanceFromTemplateByGlobalIdRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createInstanceFromTemplateByGlobalId',
  auth: 'app',
  fingerprint: '6AiOYsmRC03o-EQ3I6ABhxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneAgentInstance',
  auth: 'app',
  fingerprint: '6Q3FXpGQ29no-EQ3I6ABhxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneAgentsForFlowRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneAgentsForFlow',
  auth: 'app',
  fingerprint: 'LVwvv72TyJkzOcIqWrlXfRDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstancesByTemplateIdsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getInstancesByTemplateIds',
  auth: 'app',
  fingerprint: 'Bao0fja8a34T8OCOt-7DyBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstancesByGlobalIdRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getInstancesByGlobalId',
  auth: 'app',
  fingerprint: 'yPtD4Qwpkj8m9KEBSL8GZRDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const uploadFilesToAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'uploadFilesToAgentInstance',
  auth: 'app',
  fingerprint: '4YA1yvjO9URxAYHD89ObpBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const findComponentUsageRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'findComponentUsage',
  auth: 'app',
  fingerprint: 'Vivm1MorVsTYT3KwyiBECxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceOwnerRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceOwner',
  auth: 'app',
  fingerprint: 'biKggbtMJGFzxnLXxOhAlxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceFromSnapshotRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceFromSnapshot',
  auth: 'app',
  fingerprint: 'vxmtmtyT79xxAYHD89ObpBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneInstanceFromSnapshotRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneInstanceFromSnapshot',
  auth: 'app',
  fingerprint: '5_egGuqK0dno-EQ3I6ABhxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitPromptFeedbackRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'submitPromptFeedback',
  auth: 'app',
  fingerprint: 'oe59OesdG8tzxnLXxOhAlxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateAgentInstanceReadinessRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'validateAgentInstanceReadiness',
  auth: 'app',
  fingerprint: 'RL-pLGARj9ZHKNNd4MLGeBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateAgentInstanceReadinessV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'validateAgentInstanceReadinessV2',
  auth: 'app',
  fingerprint: '_y3TSpR__PPlnnLyhTfIORDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkValidateAgentInstancesReadinessRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkValidateAgentInstancesReadiness',
  auth: 'app',
  fingerprint: 'ate6fB_EofplU4ciiiItdhDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkCreateAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkCreateAgentInstances',
  auth: 'app',
  fingerprint: 'zWIRQ8KrqX2K51OTcYhEeBDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkCreateAgentInstancesByKeyRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkCreateAgentInstancesByKey',
  auth: 'app',
  fingerprint: 'g-3e-muZPRX6pub1YmpUKhDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkUpdateAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkUpdateAgentInstances',
  auth: 'app',
  fingerprint: '_lFoNqX2tHVi23aa1Fj6fhDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkSoftDeleteAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkSoftDeleteAgentInstances',
  auth: 'app',
  fingerprint: 'lQSah62WeHRlIE2fHG1QwxDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentConnectionsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentConnections',
  auth: 'app',
  fingerprint: 'L5P9kdUDyVuiFXWnWHuO5hDs0rHWXal4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};